import React from "react";
import ReactDOM from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import store, { RootState } from "./redux/store/store";
import AppV1 from "./V1/App";
import AppV2 from "./V2/App";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// import { toggleVersion } from "./redux/actions/versionActions";
// import { v2Paths, v2Queries } from './config/versionRoutes';

// const currentPath = window.location.pathname;
// const currentSearch = window.location.search;
// const mustForceV2 = v2Paths.some(path => currentPath.startsWith(path)) || v2Queries.some(query => currentSearch.includes(query));

// if (mustForceV2) {
// 	localStorage.setItem("version", "V2");
// 	store.dispatch(toggleVersion());
// }

const RootComponent = () => {
    const version = useSelector(
        (state: RootState) => state.VersionReducer.activeVersion
    );
    return version === "V1" ? <AppV1 /> : <AppV2 />;
};

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
    <React.StrictMode>
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
        >
            <Provider store={store}>
                <RootComponent />
            </Provider>
        </GoogleReCaptchaProvider>
    </React.StrictMode>
);
